import {
  ConfigurationFormType,
  ConfigurationPageTables,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

const SURQUAL_COUNTRY_PAGE_COUNTRY_GROUP2_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  path: "groups-2",
  label: "COUNTRY_GROUP_2",
  model: {
    entityName: "short_name",
    label: "COUNTRY_GROUP_2",
    path: "/api/country-groups-2",
    name: "country_groups_2",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/country-groups-2/export" },
    import: { path: "/api/country-groups-2/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
    ],
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
    ],
    deletable: true,
  },
};

const SURQUAL_COUNTRY_PAGE_COUNTRY_GROUP1_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "COUNTRY_GROUP_1",
  path: "groups-1",
  model: {
    entityName: "short_name",
    label: "COUNTRY_GROUP_1",
    path: "/api/country-groups-1",
    name: "country_group1",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "group2.short_name",
        order: 4,
        label: "COUNTRY_GROUP_2",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/country-groups-1/export" },
    import: { path: "/api/country-groups-1/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/country-groups-2/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "group2",
        label: "COUNTRY_GROUP_2",
        labelKey: "short_name",
        subCreationForm: SURQUAL_COUNTRY_PAGE_COUNTRY_GROUP2_TAB,
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group2",
        flex: "50%",
      },
    ],
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group2",
        flex: "50%",
      },
    ],
    deletable: true,
  },
};

const SURQUAL_COUNTRY_PAGE_COUNTRY_TAB: ConfigurationPageTables = {
  description: "CONF_DESC_SELFMAPPING_COUNTRY",
  type: ConfigurationPageType.TABLE,
  label: "COUNTRY",
  path: "",
  model: {
    entityName: "short_name",
    label: "COUNTRY",
    path: "/api/countries",
    bulkPath: "/api/countries/bulk-updates",
    name: "Pays",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 2,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 3,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 4,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "group1.short_name",
        order: 5,
        label: "COUNTRY_GROUP_1",
        visible: true,
      },
      {
        key: "country_nandc.short_name",
        order: 6,
        label: "COUNTRY_NC",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/countries/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/countries/export" },
    import: { path: "/api/countries/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/country-groups-1/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "group1",
        label: "COUNTRY_GROUP_1",
        labelKey: "short_name",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/countries-nandc/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "country_nandc",
        label: "COUNTRY_NC",
        labelKey: "short_name",
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
    ],
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group1",
        flex: "50%",
      },
      {
        key: "country_nandc",
        flex: "50%",
      },
    ],
    copyable: false,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group1",
        flex: "50%",
      },
      {
        key: "country_nandc",
        flex: "50%",
      },
    ],
    editSelectedOptions: [
      {
        key: "group1",
        flex: "50%",
      },
      {
        key: "country_nandc",
        flex: "50%",
      },
    ],
    deletable: true,
  },
};

export const SURQUAL_COUNTRY_PAGE = {
  type: ConfigurationPageType.TABS,
  count: 0,
  description: "CONF_PAGE_DESC_DEFAULT",
  label: "COUNTRY",
  pageLabel: "COUNTRY_TITLE_SURQUAL",
  menuLabel: "COUNTRY",
  name: "country",
  path: "pays",
  tabs: [
    SURQUAL_COUNTRY_PAGE_COUNTRY_TAB,
    SURQUAL_COUNTRY_PAGE_COUNTRY_GROUP1_TAB,
    SURQUAL_COUNTRY_PAGE_COUNTRY_GROUP2_TAB,
  ],
};
